import { useLocation, useNavigate } from "react-router-dom";
import { Button } from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight } from "@fortawesome/free-solid-svg-icons";
import { memo } from "react";

interface DefaultAddNewHeaderProps {
  entityName: string;
}

export const DefaultAddNewHeader = memo(({ entityName }: DefaultAddNewHeaderProps) => {
  const location = useLocation();
  const navigate = useNavigate();

  return (
    <div className="flex border-b mb-5 p-2 border-gray-300" style={{ borderBottomStyle: "solid" }}>
      <h4 className="flex-auto m-0">
        افزودن ({entityName}) <span className="text-violet-500">جدید</span>
      </h4>
      <Button
        type="link"
        title="لغو افزودن جدید و بازگشت به صفحه اصلی"
        onClick={() => navigate(location.pathname.replace("/new", ""), { state: location.state })}
        icon={<FontAwesomeIcon className="anticon align-middle" icon={faArrowRight} />}>
        لغو
      </Button>
    </div>
  );
});
